<template>
  <div></div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "Reset",
    beforeRouteEnter(to, from, next) {
      next(vm => vm.resetApplication())
    },
    computed: {
      ...mapGetters("abiturient", ["abiturient"]),
    },
    methods: {
      async resetApplication() {
        if (!this.abiturient.current_application_id) {
          return this.$router.push({name: 'profile_application_list'})
        }

        await this.$store.dispatch("application/retrieveApplication", this.abiturient.current_application_id)
          .then(() => {
            this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {
              current_application_id: null,
              current_application_step: 1,
              priority_agree: false,
              target_agree: false,
              progress_agree: false,
            })
            this.$store.commit("application/CHANGE_APPLICATION", {
              is_delete: true
            })
            Promise.all([
              this.$store.dispatch("abiturient/update"),
              this.$store.dispatch("application/updateApplication"),
            ]).finally(() => {
              this.$store.commit("application/RESET_APPLICATION")
              this.$router.push({name: 'profile_application'})
            })
          })
          .catch(() => {
            this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {
              current_application_id: null,
              current_application_step: 1,
              priority_agree: false,
              target_agree: false,
              progress_agree: false,
            })
            Promise.all([
              this.$store.dispatch("abiturient/update"),
            ]).finally(() => {
              this.$store.commit("application/RESET_APPLICATION")
              this.$router.push({name: 'profile_application'})
            })
          })
      }
    }
  }
</script>
